document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('header'); // adjust selector
    const sidebar = document.querySelector('.collection-sidebar');

    function setSidebarHeight() {
        if (window.innerWidth >= 992) { // only apply on 992px and above
            const headerHeight = header.offsetHeight;
            const finalHeight = headerHeight + 30;
            sidebar.style.height = `calc(100vh - ${finalHeight}px)`;
        } else {
            sidebar.style.height = 'auto'; // reset on smaller screens
        }
    }

    // Initial height
    setSidebarHeight();

    // Update on window resize
    window.addEventListener('resize', setSidebarHeight);
});
